import { render, staticRenderFns } from "./EditarFolga.vue?vue&type=template&id=b90afcda"
import script from "./EditarFolga.vue?vue&type=script&lang=js"
export * from "./EditarFolga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports